import React from "react";
import { useSelector } from "react-redux";
import { Language } from "../../../redux/store/base/language";

import Home from "../../../assets/images/Icons/Links/Home.svg";
import FriendsPosts from "../../../assets/images/Icons/Links/Friends Posts.svg";
import Bookmarks from "../../../assets/images/Icons/Links/Bookmarks.svg";
import Appointments from "../../../assets/images/Icons/Links/Appointments.svg";
import files from "../../../assets/images/Icons/Links/My files.svg";
import Contacts from "../../../assets/images/Icons/Links/My Contacts.svg";
import Groups from "../../../assets/images/Icons/Links/Groups.svg";

//Style
import { MDBListGroup, MDBListGroupItem } from "mdbreact";
import "./SideBarRight.scss";

const SideBarRight = (props: {}) => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );

  return (
    <MDBListGroup className="side-rigth pr-0">
      <MDBListGroupItem>
        <img src={Home} className="d-inline-inline mx-3" alt={"Home"} />
        {state?.home}
      </MDBListGroupItem>
      <MDBListGroupItem>
        <img src={FriendsPosts} className="d-inline-inline mx-3" alt={"Home"} />
        {state?.friendsPosts}
      </MDBListGroupItem>
      <MDBListGroupItem>
        <img src={Bookmarks} className="d-inline-inline mx-3" alt={"Home"} />
        {state?.bookmarks}
      </MDBListGroupItem>
      <MDBListGroupItem>
        <img src={Appointments} className="d-inline-inline mx-3" alt={"Home"} />
        {state?.friendsPosts}
      </MDBListGroupItem>
      <MDBListGroupItem>
        <img src={files} className="d-inline-inline mx-3" alt={"Home"} />
        {state?.myFiles}
      </MDBListGroupItem>
      <MDBListGroupItem>
        <img src={Contacts} className="d-inline-inline mx-3" alt={"Home"} />
        {state?.myContacts}
      </MDBListGroupItem>
      <MDBListGroupItem>
        <img src={Groups} className="d-inline-inline mx-3" alt={"Home"} />
        {state?.groups}
      </MDBListGroupItem>
    </MDBListGroup>
  );
};

export default SideBarRight;
